<small class="debug">{{ me }}</small>
<div class="block-layout-container">
    <form class="layout-form">

        <!-- Name Field Section -->
        @if (sceneSpecificProps && experienceLevel > experienceLevelType.BEGINNER) {
            <div class="name-section">
                <mat-form-field class="name-field">
                    <mat-label>{{ 'placeholder.name' | transloco }}</mat-label>
                    <input inputrestriction="basic1" autocomplete="off" (change)="onChange('label')" type="text"
                           name="label" [(ngModel)]="model.label" matInput placeholder="" />
                </mat-form-field>
            </div>
        }

        <!-- Layout Controls Section -->
        <div class="layout-controls-section">
                <!-- Rotator Section -->
                @if (experienceLevel > experienceLevelType.BEGINNER && sceneSpecificProps) {
                    <div class="rotator-section" [ngClass]="{'disable-knob': model.locked == 'true'}">
                        <app-rotator class="rotator-control" id="rotator" [value]="model.rotation"
                                     (changed)="onChange('rotation', null, $event)"></app-rotator>
                    </div>
                }

                <!-- Resolution Presets Dropdown -->
                @if (!sceneSpecificProps) {
                    <div class="resolution-presets">
                        <mat-form-field class="resolution-dropdown">
                            <mat-label>Resolution Presets</mat-label>
                            <mat-select (selectionChange)="onResolutionPresetSelected($event.value)" value="">
                                <mat-option value="">Select Resolution</mat-option>
                                @for (preset of resolutionPresets; track preset) {
                                    <mat-option [value]="preset">{{ preset }}</mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                }

                <!-- Dimension Controls -->
                <div class="dimensions-vertical">
                    <div class="control-group">
                        <app-drop-number-selector
                            [label]="('placeholder.width' | transloco)"
                            [value]="model.width || 100"
                            [min]="50"
                            [max]="8192"
                            [step]="10"
                            [showManualInput]="true"
                            [presetValues]="[100, 200, 400, 800, 1200, 1600, 1920, 2560, 3840]"
                            (onChange)="onNumberSelectorChange('width', $event)"
                            [class.disabled]="model.locked == 'true'">
                        </app-drop-number-selector>
                    </div>

                    <div class="control-group">
                        <app-drop-number-selector
                            [label]="('placeholder.height' | transloco)"
                            [value]="model.height || 100"
                            [min]="50"
                            [max]="8192"
                            [step]="10"
                            [showManualInput]="true"
                            [presetValues]="[100, 200, 400, 600, 900, 1080, 1200, 1440, 2160]"
                            (onChange)="onNumberSelectorChange('height', $event)"
                            [class.disabled]="model.locked == 'true'">
                        </app-drop-number-selector>
                    </div>

                    @if (sceneSpecificProps) {
                        <div class="control-group">
                            <app-drop-number-selector
                                label="X"
                                [value]="model.x || 0"
                                [min]="0"
                                [max]="sceneWidth"
                                [step]="5"
                                [showManualInput]="true"
                                [presetValues]="[0, 50, 100, 200, 300, 400, 500]"
                                (onChange)="onNumberSelectorChange('x', $event)"
                                [class.disabled]="model.locked == 'true'">
                            </app-drop-number-selector>
                        </div>

                        <div class="control-group">
                            <app-drop-number-selector
                                label="Y"
                                [value]="model.y || 0"
                                [min]="0"
                                [max]="sceneHeight"
                                [step]="5"
                                [showManualInput]="true"
                                [presetValues]="[0, 50, 100, 200, 300, 400, 500]"
                                (onChange)="onNumberSelectorChange('y', $event)"
                                [class.disabled]="model.locked == 'true'">
                            </app-drop-number-selector>
                        </div>
                    }
                </div>
        </div>
        <div>
            <br />
            @if (sceneSpecificProps && experienceLevel > experienceLevelType.BEGINNER) {
                <mat-checkbox (change)="onChange('lock', $event.checked)" [checked]="model.locked === 'true'">
                    {{ 'general.lockInPlace' | transloco }}
                </mat-checkbox>
                <br />
            }

            @if (experienceLevel > experienceLevelType.BEGINNER) {
                <mat-checkbox (change)="onChangeScaling($event.checked)" [checked]="model.autoScaling === '1'">
                    {{ 'general.autoScaling' | transloco }}
                </mat-checkbox>
            }
        </div>
    </form>
    <div class="constraintWrap">
        @if (sceneSpecificProps && experienceLevel > experienceLevelType.BEGINNER) {
            <app-constraint-checker [setModel]="model" (changed)="onChange($event)"></app-constraint-checker>
        }
    </div>
    <br />
    <br />
</div>
